import { Container, Grid, Link, Box, } from '@mui/material';
import React from 'react';
import OurCover from '../../Component/OurCover/OurCover';
import Clients from '../../Component/Clients/Clients';
import ServiceScss from './OurService.module.scss';
import SkillPhoto from '../../Common/Image/skills.jpg';
import Improve from '../../Component/Improve/Improve';


function OurService() {
    return (
        <div>
            <OurCover ourHead='Our services' title='We help startups and digital agencies launch projects on time' />
            {/* creative */}
            <section id={ServiceScss.creative}>
                <Container maxWidth='lg'>
                    <Grid container>
                        <Grid item xs={12} md={6}>
                            <Box className={ServiceScss.creativeLeft}>
                                <p>We provide the solutions to grow your businees</p>
                                <Link href='#'>let's talk</Link>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box className={ServiceScss.creativeRight}>
                                <h4>Creative services</h4>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.<br /><br /> It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </section>
            {/* service */}
            <section id={ServiceScss.service}>
                <Grid container>
                    <Grid item xs={12} md={7} sx={{ bgcolor: '#fafafa' }}>
                        <Box className={ServiceScss.serviceLeft}>
                            <Grid container sx={{ width: 'auto' }} >
                                <Grid item xs={12} sm={6} md={6} sx={{ px: '15px' }}>
                                    <Box className={ServiceScss.serviceItem}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M0 352c0 88.38 71.63 160 160 160h64c88.38 0 160-71.63 160-160V224H0V352zM176 0H160C71.63 0 0 71.62 0 160v32h176V0zM224 0h-16v192H384V160C384 71.62 312.4 0 224 0z" /></svg>
                                        <h4>budget accounting</h4>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} sx={{ px: '15px' }}>
                                    <Box className={ServiceScss.serviceItem}>

                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M147.8 192H480V144C480 117.5 458.5 96 432 96h-160l-64-64h-160C21.49 32 0 53.49 0 80v328.4l90.54-181.1C101.4 205.6 123.4 192 147.8 192zM543.1 224H147.8C135.7 224 124.6 230.8 119.2 241.7L0 480h447.1c12.12 0 23.2-6.852 28.62-17.69l96-192C583.2 249 567.7 224 543.1 224z" /></svg>
                                        <h4>budget accounting</h4>
                                        <p>Lorem Ipsum is simply dum sum sum is simply dum sum is simply dum is simply dummy text of the printing and typesetting industry.</p>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} sx={{ px: '15px' }}>
                                    <Box className={ServiceScss.serviceItem}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256-.0078C260.7-.0081 265.2 1.008 269.4 2.913L457.7 82.79C479.7 92.12 496.2 113.8 496 139.1C495.5 239.2 454.7 420.7 282.4 503.2C265.7 511.1 246.3 511.1 229.6 503.2C57.25 420.7 16.49 239.2 15.1 139.1C15.87 113.8 32.32 92.12 54.3 82.79L242.7 2.913C246.8 1.008 251.4-.0081 256-.0078V-.0078z" /></svg>
                                        <h4>budget accounting</h4>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} sx={{ px: '15px' }}>
                                    <Box className={ServiceScss.serviceItem}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M319.1 351.1c-35.35 0-64 28.66-64 64.01s28.66 64.01 64 64.01c35.34 0 64-28.66 64-64.01S355.3 351.1 319.1 351.1zM320 191.1c-70.25 0-137.9 25.6-190.5 72.03C116.3 275.7 115 295.9 126.7 309.2C138.5 322.4 158.7 323.7 171.9 312C212.8 275.9 265.4 256 320 256s107.3 19.88 148.1 56C474.2 317.4 481.8 320 489.3 320c8.844 0 17.66-3.656 24-10.81C525 295.9 523.8 275.7 510.5 264C457.9 217.6 390.3 191.1 320 191.1zM630.2 156.7C546.3 76.28 436.2 32 320 32S93.69 76.28 9.844 156.7c-12.75 12.25-13.16 32.5-.9375 45.25c12.22 12.78 32.47 13.12 45.25 .9375C125.1 133.1 220.4 96 320 96s193.1 37.97 265.8 106.9C592.1 208.8 600 211.8 608 211.8c8.406 0 16.81-3.281 23.09-9.844C643.3 189.2 642.9 168.1 630.2 156.7z" /></svg>
                                        <h4>budget accounting</h4>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Box className={ServiceScss.serviceRight}>
                            <img src={SkillPhoto} alt='skills'></img>
                        </Box>
                    </Grid>
                </Grid>
            </section >
            {/* process */}
            <section id={ServiceScss.process}>
                <Container maxWidth='lg'>
                    <Box className={ServiceScss.procesHead}>
                        <span>working process</span>
                        <h2>We pay attention to make the perfect details working process</h2>
                    </Box>
                    <Grid container className={ServiceScss.processBody} sx={{ width: 'auto', mx: '-15px' }}>
                        <Grid item xs={12} sm={6} md={4} sx={{ px: '15px' }}>
                            <Box className={ServiceScss.processItem}>
                                <h4>Brainstorming</h4>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} sx={{ px: '15px' }}>
                            <Box className={ServiceScss.processItem}>
                                <h4>Working process</h4>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} sx={{ px: '15px' }}>
                            <Box className={ServiceScss.processItem}>
                                <h4>Product testing</h4>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </section >
            {/* improve */}
            <Improve head='Ready to Improve Your Experience' content=" It's proudly for us to build stylish" />
            {/* clients */}
            < Clients />
        </div >
    )
}

export default OurService;
